import { TAction } from '../../actions/types/action';

// Action Types
export const SET_SIDEBAR_CONTENT = 'SIDEBAR_CONTENT/SET_SIDEBAR_CONTENT';
export const SET_SIDEBAR_IS_LOADING = 'SIDEBAR_CONTENT/SET_SIDEBAR_IS_LOADING';

export type TSetSidebarContentParams = {
  slug: string;
  params: Object;
};

// Action Creator
const SidebarActionCreator = {
  setSidebarContent(slug: string, params: any): TAction<TSetSidebarContentParams> {
    return {
      type: SET_SIDEBAR_CONTENT,
      payload: {
        slug,
        params
      }
    };
  },
  setSidebarIsLoading(slug: string, isLoading: boolean): TAction<any> {
    return {
      type: SET_SIDEBAR_IS_LOADING,
      payload: {
        slug,
        isLoading
      }
    };
  }
};

export { SidebarActionCreator };
